import { render, staticRenderFns } from "./ArrowRight.vue?vue&type=template&id=88bae166&scoped=true&"
import script from "./ArrowRight.vue?vue&type=script&lang=js&"
export * from "./ArrowRight.vue?vue&type=script&lang=js&"
import style0 from "./ArrowRight.vue?vue&type=style&index=0&id=88bae166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bae166",
  null
  
)

export default component.exports